/* eslint-disable max-len */
import {
  ClaimType, ErrorCode, RAPolicyType, PLATFORM_NAME, ErrorCodeToSpecialText,
} from '@constants';
import {
  setClaimInfo, setPackageList, clearSelectedItems, setRAReasonList, setUploadChosen,
  //  setPlatform,
} from '@store';
import { getPackage, getRAReason } from '@api';

export async function getRAReasonList(dispatch) {
  const { code, data } = await getRAReason();
  if (code === 0) {
    const list = data.map((item) => ({
      ...item,
      value: item.code,
      label: item.name,
    }));
    dispatch(setRAReasonList(list));
  }
}
// 根据接口返回判断是否需要显示options页面
export const useUrlJump = async (
  {
    policyList,
    navigate,
    dispatch,
    setIsInvalidBarShow,
    platform,
  },
) => {
  const RAInfo = policyList.find((item) => RAPolicyType.includes(item.policyType));
  const path = platform ? `${platform}/` : '';

  // 只有RA,直接到选择商品页 除了garmentory_RA
  if (RAInfo && policyList.length === 1 && platform !== PLATFORM_NAME.GARMENTORY) {
    const RA_POLICYID = policyList[0]?.policyId;
    dispatch(setClaimInfo({ type: ClaimType.RA, ...policyList[0] }));
    const resp = await getPackage({ policyId: RA_POLICYID, issueType: ClaimType.RA });
    const { code, data } = resp;
    if (code === 0) {
      dispatch(setPackageList(data));

      navigate(`/${path}choose`);
      dispatch(clearSelectedItems());
      dispatch(setUploadChosen({ files: [], comments: '' }));
    } else if (ErrorCodeToSpecialText.includes(code)) {
      navigate(`/${path}error`, { state: { code, type: ClaimType.RA } });
    } else if (code === ErrorCode.Nothing) {
      const msg = 'No Seel covers found for this order. Please double check or contact support for help.';
      setIsInvalidBarShow({ show: true, message: msg });
    } else {
      navigate(`/${path}error`, { state: { code: ErrorCode.Wrong, type: ClaimType.RA } });
    }
  } else {
    navigate(`/${path}options`);
  }
};
